var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "facebook_svg__cls-1",
    d: "M12 0a12 12 0 1 0 12 12A12 12 0 0 0 12 0Zm3 8h-1.35c-.54 0-.65.22-.65.78V10h2l-.21 2H13v7h-3v-7H8v-2h2V7.69C10 5.92 10.93 5 13 5h2Z",
    "data-name": "Layer 1"
  }))));
};

export { SvgFacebook as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICA8ZGVmcz4KICAgIDxzdHlsZT4KICAgICAgPCEtLSAuY2xzLTEgewogICAgICAgIGZpbGw6ICMwMTAxMDE7CiAgICAgIH0gLS0+CiAgICA8L3N0eWxlPgogIDwvZGVmcz4KICA8dGl0bGU+ZmFjZWJvb2stNDg8L3RpdGxlPgogIDxnIGlkPSJMYXllcl8yIiBkYXRhLW5hbWU9IkxheWVyIDIiPgogICAgPGcgaWQ9IkxheWVyXzEtMiIgZGF0YS1uYW1lPSJMYXllciAxIj4KICAgICAgPHBhdGggaWQ9ImZhY2Vib29rLTQiIGNsYXNzPSJjbHMtMSIgZD0iTTEyLDBBMTIsMTIsMCwxLDAsMjQsMTIsMTIsMTIsMCwwLDAsMTIsMFptMyw4SDEzLjY1Yy0uNTQsMC0uNjUuMjItLjY1Ljc4VjEwaDJsLS4yMSwySDEzdjdIMTBWMTJIOFYxMGgyVjcuNjlDMTAsNS45MiwxMC45Myw1LDEzLDVoMloiLz4KICAgIDwvZz4KICA8L2c+Cjwvc3ZnPgo=";